import { render, staticRenderFns } from "./loginpwd.vue?vue&type=template&id=2b1439bf&"
import script from "./loginpwd.vue?vue&type=script&lang=js&"
export * from "./loginpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports